var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"size":_vm.size,"options":_vm.options,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"parameters":_vm.parameters},on:{"change":_vm.dynamicHandleChange},model:{value:(_vm.provinces),callback:function ($$v) {_vm.provinces=$$v},expression:"provinces"}})
}
var staticRenderFns = []

export { render, staticRenderFns }